package pl.decks.personal.components.widgets.sitckybg

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.BoxScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.style.toModifier

@Composable
fun StickyBackground(
    modifier: Modifier = Modifier,
    content: @Composable BoxScope.() -> Unit,
) = Box(
    StickyBackgroundStylesheet.Container.toModifier().then(modifier),
    contentAlignment = Alignment.Center,
) {
    this.content()
}
